import React from "react";
import { graphql, useFragment } from "react-relay";

import { newsletter as newsletterData } from "shared/data/newsletter";

import { pathname as newsletterPathName } from "scmp-app/pages/newsletters";
import type { mobileNewsletterPreviewNewsletter$key } from "scmp-app/queries/__generated__/mobileNewsletterPreviewNewsletter.graphql";

import IconArrow from "./icon-arrow.svg";
import IconMail from "./icon-mail.svg";
import {
  Container,
  Footer,
  FooterText,
  FooterTitle,
  Header,
  MyNewsButton,
  NewsletterLabel,
  StyledBaseLink,
  StyledIconClock,
  StyledIframe,
  StyledSignUpButton,
  Summary,
  Title,
} from "./styles";

export type Props = React.DetailsHTMLAttributes<HTMLDivElement> & {
  className?: string;
  reference: mobileNewsletterPreviewNewsletter$key;
};

export const MobileNewsletterPreview: React.FC<Props> = ({ reference, ...props }) => {
  const newsletter = useFragment(
    graphql`
      fragment mobileNewsletterPreviewNewsletter on Newsletter {
        entityId
        name
        summary {
          text
        }
        sourceUrl
        ...signUpButtonNewsletter
      }
    `,
    reference,
  );

  return (
    <Container {...props}>
      <Header>
        <StyledBaseLink pathname={newsletterPathName} query={{}}>
          <IconMail />
          <IconArrow />
        </StyledBaseLink>
        <Title>
          Preview: <NewsletterLabel>{newsletter.name}</NewsletterLabel>
        </Title>
      </Header>
      <StyledIframe src={newsletter.sourceUrl ?? ""} />
      <Footer>
        <FooterText>Sign up for</FooterText>
        <FooterTitle>{newsletter.name}</FooterTitle>
        <Summary>
          <StyledIconClock />
          {newsletter.summary?.text}
        </Summary>
        {newsletter.entityId === newsletterData.myNews.entityId ? (
          <MyNewsButton anchorProps={{ "aria-label": "my news" }} as="/mynews" pathname="mynews">
            Set Up Now
          </MyNewsButton>
        ) : (
          <StyledSignUpButton reference={[newsletter]} />
        )}
      </Footer>
    </Container>
  );
};

MobileNewsletterPreview.displayName = "MobileNewsletterPreview";
